import { Component, OnInit, Input, ViewEncapsulation, OnDestroy, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MapV2Service } from './mapv2.service';
import { Map } from './models/Map';
import { MapV2PlacesComponent } from './mapv2-places/mapv2-places.component';
import { MapV2Change } from './models/MapV2Change';

@Component({
  selector: 'mapv2',
  templateUrl: './mapv2.component.html',
  styleUrls: ['./mapv2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MapV2Component implements OnInit, OnDestroy, OnChanges {
  public map: Map | null;
  private unsubscribe$: Subject<void>;

  @Input()
  public eventId!: string;

  @Input()
  public sectorId?: string;

  @Output()
  public change: EventEmitter<MapV2Change>;

  constructor(
    private service: MapV2Service,
    private dialog: MatDialog,
  ) {
    this.unsubscribe$ = new Subject();
    this.change = new EventEmitter();
    this.map = null;
  }

  public ngOnInit(): void {
    this.service.loadSectors(this.eventId);
    this.service.loadMap(this.eventId)
      .then(map => {
        this.map = map;

        this.service.isShowing()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: (show) => {
              if (show) {
                this.dialog.open(MapV2PlacesComponent, {
                  disableClose: true,
                  autoFocus: false,
                  panelClass: 'mapv2-dialog',
                  maxWidth: '100vw',
                });
              } else {
                this.dialog.closeAll();
              }
            }
          });

        this.service.listenReserves()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe({
            next: (event) => {
              if (event) {
                this.change.emit(event);
              }
            }
          });
      });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.complete();
    this.unsubscribe$.next();
  }

  public ngOnChanges(): void {
    if (this.sectorId) {
      this.service.setSelectedSectorById(this.sectorId);
    }
  }
}
